import React, { useState } from 'react';
import { connect } from 'react-redux';
import mapPreviewAnimation from '../../assets/hintarts/map_preview_animation.gif';
import markerIdentity from '../../assets/hintarts/marker_identity.png';
import breifMarkerModalAnimation from '../../assets/hintarts/brief_marker_modal.gif';
import statusIdentity from '../../assets/hintarts/status_identity.png';
import markerIdentityWeb from '../../assets/hintarts/marker_identity_web.png';
import * as MDICONS from '@material-ui/icons';
function MapGuide(props) {
    const { modalTitleStyle, modalImpInfoTextStyle, modalInfoTextStyle, formLabelStyle, commons } = props;
    const [openCardToggleOne, setOpenCardToggleOne] = useState(true);
    const [openCardToggleTwo, setOpenCardToggleTwo] = useState(true);
    const [openCardToggleThree, setOpenCardToggleThree] = useState(true);
    const [openCardToggleFour, setOpenCardToggleFour] = useState(true);
    const [openCardToggleFive, setOpenCardToggleFive] = useState(true);
    const [openCardToggleSix, setOpenCardToggleSix] = useState(true);


    const cardToggle = (num) => {
        switch (num) {
            case 0: {
                setOpenCardToggleOne(!openCardToggleOne);
                break;
            }
            case 1: {
                setOpenCardToggleTwo(!openCardToggleTwo);
                break;
            }
            case 2: {
                setOpenCardToggleThree(!openCardToggleThree);
                break;
            }
            case 3: {
                setOpenCardToggleFour(!openCardToggleFour);
                break;
            }
            case 4: {
                setOpenCardToggleFive(!openCardToggleFive);
                break;
            }
            case 5: {
                setOpenCardToggleSix(!openCardToggleSix);
                break;
            }

            default: {

            }

        }

    }
    return (
        <div className="dynamicModalContainer">
            <div className="dynamicModalSm">
                <div className="px-3">
                    <p style={modalTitleStyle}>Instant help?</p>
                    <p style={{ fontSize: "14px" }}>Common help guides that would help you record effectively. Reopen this by clicking the 'question mark' on top right.</p>


                    {/*  Interactivity and experience */}
                    <div className="card p-2" data-toggle="collapse" href="#collapse1" role="button" aria-expanded="true" aria-controls="collapse1">
                        <div className="d-flex justify-content-between">
                            <p className="" style={formLabelStyle}>Interactivity and experience</p>
                            <button className="btn btn-sm" onClick={() => { cardToggle(0) }}>
                                {openCardToggleOne ? <div><MDICONS.KeyboardArrowUp style={{ scale: "1.5" }} /></div> : <div><MDICONS.KeyboardArrowDown style={{ scale: "1.5" }} /></div>}
                            </button>
                        </div>

                        <div className="collapse show" id="collapse1">
                            <div className="" style={{ border: 'none' }}>
                                <p style={{ fontSize: "14px" }}>Zooming: Use zoom buttons that are available above the interactive {commons.drawing}.</p>
                                <p style={{ fontSize: "14px" }}>Panning: After you have zoomed in, use your mouse and click/tap anywhere and start dragging</p>
                                <p style={{ fontSize: "14px" }}>Hints: It can be a hassle to recoginze which tag or elevation you are viewing on the map. Hover the pin to instanly see the titles and elevation's progress.</p>
                                <div className="d-flex justify-content-center m-1"><img src={mapPreviewAnimation} alt="gif" width="300px" height="300px" /></div>
                            </div>
                        </div>
                    </div>

                    {/* Record tag or elevation */}
                    <div className="card mt-2 p-2" data-toggle="collapse" href="#collapse2" role="button" aria-expanded="true" aria-controls="collapse2">
                        <div className="d-flex justify-content-between">
                            <p className="" style={formLabelStyle}>Record tag or elevation</p>
                            <button className="btn btn-sm" onClick={() => { cardToggle(1) }}>
                                {openCardToggleTwo ? <div><MDICONS.KeyboardArrowUp style={{ scale: "1.5" }} /></div> : <div><MDICONS.KeyboardArrowDown style={{ scale: "1.5" }} /></div>}
                            </button>
                        </div>

                        <div className="collapse show" id="collapse2">
                            <div className="" style={{ border: 'none' }}>
                                <p style={{ fontSize: '14px' }}>
                                    To add a marker, you will first need to toggle the button to record mode and
                                    then click or tap anywhere on the {commons.drawing} to place a marker.
                                    Press any positive button (such as submit) to confirm.</p>
                            </div>
                        </div>
                    </div>

                    {/* Identiying tag or elevation */}
                    <div className="card mt-2 p-2" data-toggle="collapse" href="#collapse3" role="button" aria-expanded="true" aria-controls="collapse3">

                        <div className="d-flex justify-content-between">
                            <p className="" style={formLabelStyle}>Identiying tag or elevation</p>
                            <button className="btn btn-sm" onClick={() => { cardToggle(2) }}>
                                {openCardToggleThree ? <div><MDICONS.KeyboardArrowUp style={{ scale: "1.5" }} /></div> : <div><MDICONS.KeyboardArrowDown style={{ scale: "1.5" }} /></div>}
                            </button>
                        </div>

                        <div class="collapse show" id="collapse3">
                            <div class="" style={{ border: 'none' }}>
                                <div className="d-flex justify-content-center m-2"><img src={markerIdentity} alt="gif" width="300px" height="300px" /></div>
                            </div>
                        </div>
                    </div>

                    {/* View tag or elevation*/}
                    <div className="card mt-2 p-2" data-toggle="collapse" href="#collapse4" role="button" aria-expanded="true" aria-controls="collapse4">
                        <div className="d-flex justify-content-between">
                            <p className="" style={formLabelStyle}>View tag or elevation</p>
                            <button className="btn btn-sm" onClick={() => { cardToggle(3) }}>
                                {openCardToggleFour ? <div><MDICONS.KeyboardArrowUp style={{ scale: "1.5" }} /></div> : <div><MDICONS.KeyboardArrowDown style={{ scale: "1.5" }} /></div>}
                            </button>
                        </div>

                        <div class="collapse show" id="collapse4">
                            <div class="" style={{ border: 'none' }}>
                                <p style={{ fontSize: "14px" }}>Clicking on any of the recorded markers on the canvas will show you a section containing its summary.</p>
                                <div className="d-flex justify-content-center"><img src={breifMarkerModalAnimation} alt="gif" width="300px" height="200px" /></div>
                            </div>
                        </div>
                    </div>

                    {/* List of recording */}
                    <div className="card mt-2 p-2" data-toggle="collapse" href="#collapse5" role="button" aria-expanded="true" aria-controls="collapse5">
                        <div className="d-flex justify-content-between">
                            <p className="" style={formLabelStyle}>List of recordings</p>
                            <button className="btn btn-sm" onClick={() => { cardToggle(4) }}>
                                {openCardToggleFive ? <div><MDICONS.KeyboardArrowUp style={{ scale: "1.5" }} /></div> : <div><MDICONS.KeyboardArrowDown style={{ scale: "1.5" }} /></div>}
                            </button>
                        </div>

                        <div class="collapse show" id="collapse5">
                            <div class="" style={{ border: 'none' }}>
                                <div className="d-flex justify-content-center m-2"><img src={markerIdentityWeb} alt="gif" width="300px" height="300px" /></div>
                            </div>
                        </div>
                    </div>

                    {/* Status color */}
                    <div className="card mt-2 p-2" data-toggle="collapse" href="#collapse6" role="button" aria-expanded="true" aria-controls="collapse6">
                        <div className="d-flex justify-content-between">
                            <p className="" style={formLabelStyle}>Status colors</p>
                            <button className="btn btn-sm" onClick={() => { cardToggle(5) }}>
                                {openCardToggleSix ? <div><MDICONS.KeyboardArrowUp style={{ scale: "1.5" }} /></div> : <div><MDICONS.KeyboardArrowDown style={{ scale: "1.5" }} /></div>}
                            </button>
                        </div>

                        <div class="collapse show" id="collapse6">
                            <div class="" style={{ border: 'none' }}>
                              <div className="d-flex justify-content-center m-2"><img src={statusIdentity} alt="gif" width="300px" height="300px" /></div>  
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    // console.log(state.firebase.data.Company)
    return {
        themeColors: state.theme,
        modalWidth: state.appControl.modalWidthMedium,
        modalHeight: state.appControl.modalHeightMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalImpInfoTextStyle: state.appControl.modalImpInfoTextStyle,
        formLabelStyle: state.appControl.formLabelStyle,
        commons: state.commons,
    }
}

export default connect(mapStateToProps)(MapGuide);